import React, { Component } from "react"
import { withStyles } from "@material-ui/core"

import { Cookies } from "react-cookie"
import Grid from "@material-ui/core/Grid"
import Fab from "@material-ui/core/Fab"
import DeleteIcon from "@material-ui/icons/Delete"
import Snackbar from "@material-ui/core/Snackbar"
import { Alert, AlertTitle } from "@material-ui/lab"
import Typography from "@material-ui/core/Typography"
import * as constants from "../constants"

const styles = (theme) => ({
      button: {
            margin: theme.spacing.unit,
      },
      small: {
            width: theme.spacing(4),
            height: theme.spacing(4),
      },
})

class ExpertExtraEmployee extends Component {
      cookies = new Cookies()
      constructor(props) {
            super(props)

            this.state = {
                  bodycarExtracarState: this.props.expertExtraEmployee,
                  employee_name: this.props.expertExtraEmployee.employee_name,
                  employee_family: this.props.expertExtraEmployee.employee_family,
                  visible: true,
                  snackstr: "",
                  showSnack: false,
                  snackMode: "success",
            }
      }
      componentDidMount() {}

      handleClickcloseTasckBar = (event) => {
            this.setState({ showSnack: false })
      }

      deleteInstalmentCondition = () => {
            const { bodycarExtracarState } = this.state

            var self = this
            var xhttp = new XMLHttpRequest()
            xhttp.onreadystatechange = function() {
                  if (this.readyState === 4 && this.status === 200) {
                        var arr = JSON.parse(this.responseText)
                        console.log(arr)
                        if (arr.result === "ok") {
                              self.setState({ visible: false, snackstr: arr.desc, showSnack: true, snackMode: "success" })
                        } else if (arr.result === "error") {
                              self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "error" })
                        }
                  }
            }
            var fd = new FormData()
            fd.append("command", "delete_expert_extraemployee")
            fd.append("expert_extra_id", bodycarExtracarState.expert_extra_id)
            xhttp.open("POST", `${constants.BASE_URL}/expert`)
            xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"))
            xhttp.send(fd)
      }

      render() {
            const { classes } = this.props
            const { snackMode, snackstr, showSnack, visible, employee_name, employee_family } = this.state
            if (visible) {
                  return (
                        <Grid item xs={4}>
                              <Grid container spacing={3}>
                                    <Grid item xs={8}>
                                          <Snackbar
                                                anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
                                                onClose={this.handleClickcloseTasckBar}
                                                open={showSnack}
                                                autoHideDuration={10000}
                                          >
                                                <Alert severity={snackMode}>{snackstr}</Alert>
                                          </Snackbar>
                                          <Typography variant="h7">{employee_name + " " + employee_family}</Typography>
                                    </Grid>

                                    <Grid item xs={4}>
                                          <div style={{ width: "100%", textAlign: "left" }}>
                                                <Fab
                                                      className={classes.small}
                                                      color="secondary"
                                                      aria-label="edit"
                                                      onClick={this.deleteInstalmentCondition}
                                                >
                                                      <DeleteIcon />
                                                </Fab>
                                          </div>
                                    </Grid>
                              </Grid>
                        </Grid>
                  )
            } else {
                  return null
            }
      }
}
export default withStyles(styles)(ExpertExtraEmployee)
